export const RoutePaths = {
  admin: 'admin',
  employee: 'employee',
  authentication:'auth',
  customer: 'customer'
}
